<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="店铺:" label-width="60px">
            <el-select v-model="searchForm.storeCodeQuery" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in useObjectList" :label="item.content" :key="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频类型:">
            <el-select v-model="searchForm.videoTypeQuery" filterable clearable>
              <el-option label="全部" value="" />
              <el-option label="主图" value="1" />
              <el-option label="微详情" value="2" />
              <el-option label="抖快" value="3" />
              <el-option label="猜喜" value="4" />
            </el-select>
          </el-form-item>
          <el-form-item label="下载时间:">
            <form-date-range
              :form="searchForm"
              startKey="startTime"
              endKey="endTime"
              :usingTime="false"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <el-table
        @select="serlectRow"
        ref="tableRef"
        :height="maxTableHeight"
        border
        stripe
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template #header v-if="item.fieldType == 'string'">
            <q-table-header-filter
              :prop="item.columnName"
              :label="item.displayName"
              :useSort="true"
              :filterType="item.fieldType"
              table="shortVideoFullLog"
              :filterOptions="headerFilterOptions[item.columnName]"
              :getFilterOptions="cheoxList"
              :searchReset="searchReset"
              @confirmFilter="confirmFilter"
              @cheoxList="cheoxList"
            />
          </template>
          <template #header v-else-if="item.fieldType !== 'string'">
            <q-table-header-filter
              :prop="item.columnName"
              :label="item.displayName"
              :useSort="true"
              filterType="int"
              table="shortVideoFullLog"
              :filterOptions="headerFilterOptions[item.columnName]"
              :getFilterOptions="cheoxList"
              :width="item.displayWidth"
              :searchReset="searchReset"
              @confirmFilter="confirmFilter"
              @cheoxList="cheoxList"
            />
          </template>
          <template slot-scope="scope">
            {{ scope.row[item.columnName] }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
export default {
  name: "shortVideoFullLog",
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      loading: true,
      loading: true,
      titleName: "",
      showFlag: false,
      searchForm: {
        storeCodeQuery: "",
        videoTypeQuery: "",
        startTime: "",
        endTime: "",
        suitName: null,
      },
      rules: {},
      requestParam: {},
      reportName: "productVideoLogReport",
      dialogFormVisible: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: "auto",
      params: {
        headers: {
          "Content-Type": "application/json;charset=utf-8", // 根据后台的接参数方式前端指定请求头
        },
      },
      radio: null,
      useObjectList: [],
      columnData: [],
      columnList: [],
      headerFilterOptions: {},
      searchReset: false,
      queryCriteria: [],
      pageTure: false,
      searchFormData: [],
    };
  },
  computed: {},
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    onSearch() {
      this.$store.commit("headerFilters/delHeaderFilter", "shortVideoFullLog");
      this.tableData.pageNum = 1;
      this.searchReset = true;
      // this.$store.commit("headerFilters/delHeaderFilter", 'retirementAnalysis');
      this.queryCriteria = [
        {
          orderBy: "",
          paramName: "storeCodeQuery", //店铺
          paramValue: this.searchForm.storeCodeQuery,
          type: "string",
        },
        {
          orderBy: "",
          paramName: "videoTypeQuery", //视频类型
          paramValue: this.searchForm.videoTypeQuery,
          type: "string",
        },
        {
          orderBy: "",
          paramName: "downloadTimeQuery", //上市时间
          paramValue: this.searchForm.startTime ? this.searchForm.startTime + "," + this.searchForm.endTime : "",
          type: "between",
        },
      ];
      this.pageTure = false;
      this.init();
    },

    init(item) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.paramValue);
      let param = {
        filterData: {
          queryCriteria: filter,
          reportName: this.reportName,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      if (this.pageTure) {
        param.filterData = item.filterData;
      }
      this.searchFormData = param;
      this.$q.common.reportSearch({ data: JSON.stringify(param) }).then((res) => {
        this.tableData = res.data;
        if (null != this.tableData.records) {
          this.loading = false;
        }
        if (res.code == 200) {
          this.loading = false;
          this.pageTure = false;
          this.searchReset = false;
        }
      });
    },
    columnsArr() {
      let params = {
        params: {
          reportName: this.reportName,
        },
      };
      this.$q.common.columns(params).then((res) => {
        this.columnData = res.data.sysColumns;
      });
    },
    cheoxList(name, type) {
      this.columnList = [];
      this.columnList = JSON.parse(JSON.stringify(this.searchFormData.filterData.queryCriteria));
      let obj = {
        type: "",
        paramValue: "",
        orderBy: "",
        paramName: name,
      };
      this.columnList.forEach((v, index) => {
        if (v && v.paramName == name) {
          delete this.columnList[index];
        }
      });
      this.columnList.push(obj);
      let data = {
        colParam: this.columnList,
        reportName: this.reportName,
      };
      data.colParam = this.columnList.filter((n) => n);
      return this.$q.common.reportGetIndexInfo({ data: data }).then((res) => {
        if (type == "string") {
          this.$set(this.headerFilterOptions, name, res.data.string);
        } else {
          this.$set(this.headerFilterOptions, name, res.data.numerical);
        }
      });
    },
    confirmFilter(filterParam) {
      let that = this;
      let tableName = "shortVideoFullLog";
      this.common.confirmFilter(that, filterParam, tableName);
    },
    logsOptions() {
      this.$q.shortVideoOverview.logsOptions({}).then((res) => {
        this.useObjectList = res.data;
      });
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    resetForm() {
      this.$store.commit("headerFilters/delHeaderFilter", "shortVideoFullLog");
      this.initSearchForm();
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    initSearchForm() {
      this.searchForm = {
        storeCodeQuery: "",
        videoTypeQuery: "",
        startTime: "",
        endTime: "",
        suitName: null,
      };
    },
    onSizeChange(pageSize) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = pageSize;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    // handleSortChange({ column, prop, order }) {
    //   console.log(999);
    //   this.tableData.pageNum = 1;
    //   this.searchForm.sortField = prop;
    //   this.searchForm.sortOptions =
    //     order === "ascending" ? "0" : order === "descending" ? "1" : "",
    //     this.onSearch();
    // },
  },

  mounted() {
    this.columnsArr();
    this.onSearch();
    this.logsOptions();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important
</style>
